import { render, staticRenderFns } from "./PurchasesAccruedBonuses.vue?vue&type=template&id=d933e0ca"
import script from "./PurchasesAccruedBonuses.vue?vue&type=script&lang=js"
export * from "./PurchasesAccruedBonuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports